import { MantineProvider } from "@mantine/core";
import { Suspense } from "react";
import { ToastContainer } from "react-toastify";
import NavigationProgressBar from "../progress/NavigationProgressBar";

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <MantineProvider
      theme={{
        fontFamily: "Satoshi, sans-serif",
      }}
    >
      {/* Navigation progress for the application */}
      <Suspense fallback={null}>
        <NavigationProgressBar />
      </Suspense>

      {/* For application wide toast notifications */}
      <ToastContainer autoClose={5000} limit={1} />

      {children}
    </MantineProvider>
  );
}
